import { useFeatureFlagVariantKey } from 'posthog-js/react';

const useSetup = (name: string) => {
  const isSetup = !!useFeatureFlagVariantKey(name);

  return { isSetup };
};

export const PostHogABTest = {
  /**
   * @status 进行中
   * @description 显示banner/隐藏banner test/control
   */
  bannerABTest: {
    name: 'click_banner',
    useSetup,
    aTest: 'test',
    bTest: 'control',
  },
};
